import clsx from 'clsx';

import { ImageMedia, ImageMediaProps } from '~/shared/components/ImageMedia/ImageMedia';

import styles from './responsiveImageMedia.module.css';

export type ResponsiveImageMediaProps = Pick<ImageMediaProps, 'image' | 'sizes' | 'onLoad' | 'priority'> & {
	className?: string;
	vertical?: boolean;
};

export const ResponsiveImageMedia = ({ className, vertical, ...props }: ResponsiveImageMediaProps) => (
	<div className={clsx('responsiveImageMedia', vertical ? styles.verticalImage : styles.horizontalImage, className)}>
		<ImageMedia
			{...props}
			fill
			className="contentBase"
		/>
	</div>
);
